import pb from '../../lib/pocketbase.js';

// Get all languages
export const getAllLanguages = async () => {
  try {
    const response = await pb.collection('languages').getList(1, 100, {
      sort: 'code'
    });
    return response.items || [];
  } catch (error) {
    console.error('Error fetching languages:', error);
    throw error;
  }
};

// Get language by code
export const getLanguageByCode = async (code) => {
  try {
    const language = await pb.collection('languages').getFirstListItem(`code="${code}"`);
    return language;
  } catch (error) {
    console.error(`Error fetching language with code ${code}:`, error);
    throw error;
  }
};

// Update language JSON template
export const updateLanguageTemplate = async (languageId, jsonTemplate) => {
  try {
    const updatedLanguage = await pb.collection('languages').update(languageId, {
      json_template: JSON.stringify(jsonTemplate)
    });
    return updatedLanguage;
  } catch (error) {
    console.error('Error updating language template:', error);
    throw error;
  }
};

// Create new language (for future use)
export const createLanguage = async (languageData) => {
  try {
    const newLanguage = await pb.collection('languages').create(languageData);
    return newLanguage;
  } catch (error) {
    console.error('Error creating language:', error);
    throw error;
  }
}; 